import React from 'react';

// Toolbar filter rendered as a "Label: Value ▾" pill. The visible pill is
// plain text; a transparent native <select> is stretched over it so clicks
// anywhere on the pill open the real OS menu and keyboard/screen-reader
// behavior stays native. `defaultValue` is the "no filter" option — any
// other value gets the highlighted active style.
function FilterSelect({ label, value, onChange, options, defaultValue = '' }) {
  const selected = options.find((o) => o.value === value) || options[0];
  const active = value !== defaultValue;
  return (
    <div className={`filter-pill${active ? ' filter-pill-active' : ''}`}>
      <span className="filter-pill-label">{label}:</span>
      <span className="filter-pill-value">{selected?.label}</span>
      <select
        className="filter-pill-select"
        aria-label={label}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
    </div>
  );
}

export default FilterSelect;
